// extracted by mini-css-extract-plugin
module.exports = {"block":"e_vW","heading":"e_wW"};